import { render, staticRenderFns } from "./ChildSeat.vue?vue&type=template&id=078ca864&scoped=true"
import script from "./ChildSeat.vue?vue&type=script&lang=js"
export * from "./ChildSeat.vue?vue&type=script&lang=js"
import style0 from "./ChildSeat.vue?vue&type=style&index=0&id=078ca864&prod&lang=css"
import style1 from "./ChildSeat.vue?vue&type=style&index=1&id=078ca864&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078ca864",
  null
  
)

export default component.exports